import AbstractApi from "../AbstractApi";

class FilesApi extends AbstractApi  {

  // Files
  apiMethod = 'dashboard/sites/{:id}/files/api';
  htaccessMethod = 'dashboard/sites/{:id}/files/htaccess';


  /*--------------------------------------------------------------------------*/
  /* Files */

  async api(id) {

    this.requestMethod = this.apiMethod.replace('{:id}', id);

    this.requestData = new FormData();
    this.requestData.append('token', this.authToken);

    return await this.request();
  }


  async htaccess(id) {

    this.requestMethod = this.htaccessMethod.replace('{:id}', id);

    this.requestData = new FormData();
    this.requestData.append('token', this.authToken);

    return await this.request();
  }

}

export default FilesApi;
